import Classifications from './classifications';

export default Classifications;